import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ICurrency, ICurrencyList} from '../../shared/model/interface/currency.model.interface';
import {IObjectList} from "../../shared/model/interface/object-list.model.interface";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private URL = environment.backendUrl + '/currencies';

  constructor(private http: HttpClient) {
  }

  getAllCurrencies() {
    return this.http.get<ICurrency[]>(this.URL);
  }

  getAllCurrenciesList() {
    return this.http.get<ICurrency[]>(this.URL)      .pipe(
      map(data => ({
        data: data,
        totalCount: data.length
      } as IObjectList<ICurrency>))
    ).pipe(
      map(data => new ICurrencyList(data))
    );
  }
}
